
export function redirectWithParams(router, returnUrl: any) {
    const splittedUrl = returnUrl.split('?');
    if (splittedUrl.length === 1) {
        router.navigate([returnUrl]);
    } else {
        const queryParams = {};
        splittedUrl[1].split('&').forEach(element => {
            queryParams[element.split('=')[0]] = element.split('=')[1];
        });
        router.navigate([splittedUrl[0]], { queryParams });
    }
}